<template>
  <cy-drawer
    width="50%"
    title="添加/编辑"
    v-model="visible"
    :loading="loading"
    @cancel="cancel"
    @confirm="submit('form')"
  >
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-row :gutter="10">
        <a-col :lg="24">
          <a-form-model-item :label="$t('标题')" prop="title">
            <a-input v-model="form.title" :placeholder="$t('请输入')" :maxLength="50"></a-input>
          </a-form-model-item>
        </a-col>
        <a-col :lg="24">
          <a-form-model-item :label="$t('内容')" prop="newsContent">
            <WangEditor v-model="form.newsContent"></WangEditor>
          </a-form-model-item>
        </a-col>
      </a-row>

      <template v-if="showI18n && langList.length">
        <a-divider>{{ $t('多语言翻译') }}</a-divider>
        <a-tabs v-model="activeLang">
          <a-tab-pane v-for="lang in langList" :key="lang.dictValue" :tab="lang.dictLabel">
            <a-form-model-item :label="$t('标题') + '（' + lang.dictLabel + '）'">
              <a-input
                v-model="titleI18nMap[lang.dictValue]"
                :placeholder="$t('请输入')"
                :maxLength="50"
              />
            </a-form-model-item>
            <a-form-model-item :label="$t('内容') + '（' + lang.dictLabel + '）'">
              <WangEditor
                v-if="activeLang === lang.dictValue"
                :key="'i18n-content-' + lang.dictValue"
                v-model="contentI18nMap[lang.dictValue]"
              />
            </a-form-model-item>
          </a-tab-pane>
        </a-tabs>
      </template>
    </a-form-model>

    <a-button
      slot="footer"
      :style="{ float: 'left', marginRight: '8px' }"
      :loading="translateLoading"
      @click="handleTranslate"
    >
      {{ $t('翻译') }}
    </a-button>
  </cy-drawer>
</template>
<script>
import CyDrawer from '@/components/CyDarwer'
import { mapGetters } from 'vuex'
import { addObj, putObj, getObj, autoTranslate } from '../api'
import { pageData } from '@/api/system/dict/data'
import WangEditor from '@/components/WangEditor'
import variableMixin from '@/core/mixins'

function createEmptyForm() {
  return {
    newsContent: undefined,
    remark: undefined,
    title: undefined,
    titleI18n: undefined,
    newsContentI18n: undefined,
    id: undefined
  }
}

export default {
  name: 'CreateForm',
  mixins: [variableMixin],
  filters: {},
  components: {
    CyDrawer,
    WangEditor
  },
  props: {
    model: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      translateLoading: false,
      showI18n: false,
      langList: [],
      activeLang: undefined,
      titleI18nMap: {},
      contentI18nMap: {},
      form: createEmptyForm(),
      rules: {
        title: [{ required: true, message: this.$t('请输入') }],
        newsContent: [{ required: true, message: this.$t('请输入') }]
      }
    }
  },
  computed: {
    ...mapGetters(['roleList'])
  },
  created() {
    this.loadTranslateLangs()
  },
  methods: {
    loadTranslateLangs() {
      return pageData({
        dictType: 'cooking_translate_lang',
        pageNum: 1,
        pageSize: 100
      }).then((res) => {
        const records = (res.data && res.data.records) || []
        this.langList = records.slice().sort((a, b) => (a.dictSort || 0) - (b.dictSort || 0))
        if (this.langList.length && !this.activeLang) {
          this.activeLang = this.langList[0].dictValue
        }
        // 语言字典晚于详情返回时，补一次回显
        this.applyI18nFromForm()
      })
    },
    initI18nMaps(titleObj = {}, contentObj = {}) {
      const titleMap = {}
      const contentMap = {}
      this.langList.forEach((lang) => {
        const key = lang.dictValue
        titleMap[key] = titleObj[key] != null ? titleObj[key] : ''
        contentMap[key] = contentObj[key] != null ? contentObj[key] : ''
      })
      this.titleI18nMap = titleMap
      this.contentI18nMap = contentMap
    },
    parseI18nJson(str) {
      if (!str) return {}
      if (typeof str === 'object') return str
      try {
        const parsed = JSON.parse(str)
        if (typeof parsed === 'string') {
          // 兼容二次序列化的 JSON 字符串
          return this.parseI18nJson(parsed)
        }
        return parsed || {}
      } catch (e) {
        return {}
      }
    },
    applyI18nFromForm() {
      const titleObj = this.parseI18nJson(this.form.titleI18n)
      const contentObj = this.parseI18nJson(this.form.newsContentI18n)
      const hasData = Object.keys(titleObj).length > 0 || Object.keys(contentObj).length > 0
      if (!hasData) {
        if (this.langList.length) this.initI18nMaps()
        return
      }
      if (!this.langList.length) return
      this.initI18nMaps(titleObj, contentObj)
      this.showI18n = true
      if (!this.activeLang) {
        this.activeLang = this.langList[0].dictValue
      }
    },
    buildI18nPayload() {
      const titleObj = {}
      const contentObj = {}
      this.langList.forEach((lang) => {
        const key = lang.dictValue
        if (this.titleI18nMap[key]) titleObj[key] = this.titleI18nMap[key]
        if (this.contentI18nMap[key]) contentObj[key] = this.contentI18nMap[key]
      })
      return {
        titleI18n: Object.keys(titleObj).length ? JSON.stringify(titleObj) : undefined,
        newsContentI18n: Object.keys(contentObj).length ? JSON.stringify(contentObj) : undefined
      }
    },
    handleTranslate() {
      if (!this.form.title) {
        this.$message.warning(this.$t('请先填写标题'))
        return
      }
      if (!this.form.newsContent || this.form.newsContent === '<p><br></p>') {
        this.$message.warning(this.$t('请先填写内容'))
        return
      }
      this.translateLoading = true
      autoTranslate({
        title: this.form.title,
        newsContent: this.form.newsContent
      })
        .then((res) => {
          const data = res.data || {}
          const titleObj = this.parseI18nJson(data.titleI18n)
          const contentObj = this.parseI18nJson(data.newsContentI18n)
          this.initI18nMaps(titleObj, contentObj)
          this.showI18n = true
          if (this.langList.length && !this.activeLang) {
            this.activeLang = this.langList[0].dictValue
          }
          this.$message.success(this.$t('翻译成功'))
        })
        .finally(() => {
          this.translateLoading = false
        })
    },
    reset() {
      this.form = createEmptyForm()
      this.showI18n = false
      this.translateLoading = false
      this.initI18nMaps()
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    init(id) {
      this.reset()
      this.visible = true
      if (!this.langList.length) {
        this.loadTranslateLangs()
      }
      this.$nextTick(() => {
        if (id) {
          this.form.id = id
          this.loading = true
          getObj(id)
            .then((res) => {
              this.form = {
                ...createEmptyForm(),
                ...res.data
              }
              this.applyI18nFromForm()
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    cancel() {
      this.visible = false
      this.reset()
      this.$emit('close')
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return
        const i18n = this.buildI18nPayload()
        const payload = {
          ...this.form,
          ...i18n
        }
        this.loading = true
        const req = this.form.id ? putObj(payload) : addObj(payload)
        req
          .then(() => {
            this.cancel()
            this.$emit('refresh')
          })
          .catch(() => {
            this.loading = false
          })
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
